const $ =window.$;

export default class  Dragable {
    constructor(target,handleIn) {
        this.draggable = $(target)
        if(handleIn) {
            this.handle = $(handleIn);
        }else {
            this.handle = this.draggable;
        }
        this.onMouseDownBind = this.onMouseDown.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseUpBind = this.onMouseUp.bind(this);
        this.handle.on('mousedown', this.onMouseDownBind);
        this.drh = this.handle.css("cursor", "move");
    }
                       
    onMouseDown(e) {
        this.drh = this.handle.addClass("drag");
        this.dr=this.draggable.addClass("drag");
        this.height = this.dr.outerHeight();
        this.width = this.dr.outerWidth();
        this.max_left = this.dr.parent().offset().left + this.dr.parent().width() - this.dr.width();
        this.max_top = this.dr.parent().offset().top + this.dr.parent().height() - this.dr.height();
        this.min_left = this.dr.parent().offset().left;
        this.min_top = this.dr.parent().offset().top;
        this.ypos = this.dr.offset().top + this.height - e.pageY;
        this.xpos = this.dr.offset().left + this.width - e.pageX;
        
        $(document.body).on('mousemove', this.onMouseMoveBind );
        $(document.body).on('mouseup', this.onMouseUpBind );
        
    }
    onMouseMove(e) {
        var itop = e.pageY + this.ypos - this.height;
        var ileft = e.pageX + this.xpos - this.width;

        if (this.dr.hasClass("drag")) {
            if (itop <= this.min_top) {
                itop = this.min_top;
            }
            if (ileft <= this.min_left) {
                ileft = this.min_left;
            }
            if (itop >= this.max_top) {
                itop = this.max_top;
            }
            if (ileft >= this.max_left) {
                ileft = this.max_left;
            }
            this.dr.offset({
                top : itop,
                left : ileft
            });
        }
    }
    onMouseUp(e) {
        $(document.body).off('mousemove', this.onMouseMoveBind );
        $(document.body).off('mouseup', this.onMouseUpBind );
        this.dr.removeClass("drag");
        this.drh.removeClass("drag");
    }
}   